<!-- Itens selecionados -->
<!-- <div *ngIf="showCheckboxes"  class="selected-items__container">
  <div *ngIf="countSelectedItems > 0" class="div-selected-items">
    <h5 class="text-ent">Selecionados:</h5>
    <button class="btn btn-success selected-items" (click)="openModalSelectedItems()">
      <span>
        {{ countSelectedItems }} {{ (countSelectedItems > 1) ? 'itens' : 'item' }}
      </span>
    </button>
    <div class="div-clear-filter-button div-clear-selected-button">
      <div style="position: relative;">
        <button type="button" class="clear-filter-button clear-selected-button" ngbTooltip="Limpar Selecionados"
          placement="bottom" (click)="clearAllSelectedItems()">
          <i class="material-icons">delete_sweep</i>
        </button>
      </div>
    </div>
  </div>
</div> -->
<div class="divDetailuser" [ngStyle]="{left: divDetailLeft,
  top: divDetailTop}" *ngIf="showDetailsUser">
</div>


<div class="lex-table mt-2">

  <div class="lex-table-header" [ngClass]="activeReadOnly ? 'headerReadOnly' : 'headerDefault'">
    <div class="lex-table-row" [ngStyle]="{ padding: showStatus ? '16px 24px 16px 0px' : '' }">
      <div class="lex-table-column" *ngFor="let column of columns; let indexColumn = index" [ngStyle]="{
          width: (showCheckboxes && column.id === 'checkboxes') ? '50px' : column.name === 'Pré-matriculados' ? '40%' : column.width,
          padding: (showCheckboxes && column.id === 'checkboxes') ? '0  0 0 12px' : (showStatus && column.id === 'status') ? '0  0 0 6px' : column.name ? '0  0 0 0px' :
            (showStatus && indexColumn === 2) ? '0 24px 0 16px' : (column.actionButton || column.id === 'icon') ? '0' : '',
          paddingRight: ( column.foldable && column.foldable.content === 'foldableProduct' || column.id === 'icon') ? 0 : ''
        }">
        
        

        <!-- Texto simples do header -->
        <span *ngIf="!column.ordination && column.id !== 'acronym'" [ngStyle]="column.ngStyle || ''">{{ column.name }}</span>

        <!-- Componente de ordenação -->
        <seb-table-order [ngClass]="activeReadOnly ? 'textReadOnly' : ''" *ngIf="column.ordination"
          [sLabel]="column.name" [nIndex]="column.ordination.orderType" (click)="onSortColumn(column)">
        </seb-table-order>

        <!-- Checkbox para a seleção de todos os itens -->
        <div *ngIf="showCheckboxes && column.id === 'checkboxes'" class="d-flex">
          <label class="checkbox checkbox-outline-primary">
            <input type="checkbox" [ngModel]="areAllSelected" (change)="toggleAllSelection(origin);"
              [disabled]="readonly">
            <span class="input-span"></span>
          </label>
        </div>
        <div *ngIf="showNumberUsers && column.id === 'numberUsers'" class="numberUsersSatus"
          [ngStyle]="column.ngStyle ? column.ngStyle : ''">
          <label class="lower-case-label">{{data.length}} {{lextranslate.i18n["abe528f1-669d-4490-a7b0-39fcf7a4be49"]}}{{data.length > 1 ? 's' : ''}} </label>
        </div>
      </div>
    </div>
  </div>

  <div class="lex-table-content" [hidden]="preloader" [ngClass]="{readonly: readonly}">
    <div class="lex-table-row" *ngFor="let d of data; let indexData = index" [ngStyle]="{
        backgroundColor: indexData % 2 !== 0 ? '#f9f9f9' : '#fff',
        borderRadius: indexData === data.length - 1 ? '0 0 5px 5px' : '',
        paddingLeft: showStatus ? 0 : ''
      }" (click)="redirectToItemEdit($event, d)">

      <div class="lex-table-column" *ngFor="let column of columns; let indexColumn = index;" [ngStyle]="{
         width: (column.id === 'numberUsers') ? '0px' : column.width,
          padding: (showCheckboxes && column.id === 'checkboxes') ? '0  0 0 12px' : (showStatus && column.id === 'status') ? '3px 0 0 6px' : column.name ? '0  0 0 7px' :
            (showStatus && indexColumn === 2) ? '0 24px 0 0px' : (column.actionButton || column.id === 'icon') ? 0 : '',
          overflow: (column.foldable) ? 'inherit' : '',
          paddingRight: (column.foldable && column.foldable.content === 'foldableProduct' || column.actionButton || column.id === 'icon') ? 0 : '',
          minWidth: (column.name) ? '150px' : '',
          maxWidth: column.actionButton ? '40px' : ''
        }">

        <!-- Texto simples do body e contador -->
        <div class="d-flex " [ngClass]="activeReadOnly ? 'textReadOnly' : ''"
          *ngIf="(!column.foldable && !column.iconText && column.id !== 'status' && !column.actionButton && !column.pill && column.id !== 'icon') || column.count"
          [ngStyle]="column.ngStyle || ''">

          <ng-template #popContent>
            <div class="popoverOptionMenu" style="width: 330px">
              <div class="popoverMaxWidth">
                <div id="optionMenu" class="container">

                  <div class="acronymName">{{getAcronym(d[column.id])}}</div>
                  <div class="row headPopover">
                    <div class="col-3">

                    </div>
                    <div class="col-9 " style="display: flex;align-self: center;">
                      {{ d[column.id] }}
                    </div>
                  </div>
                  <div class="row footerPopover">
                    <div class="col-3"></div>
                    <div class="col-9 " style="display: flex;align-self: center; ">
                      <div class="container">
                        <div class="row"><span><b>{{lextranslate.i18n['672cce3b-477f-4600-b471-b0ca4f3c6b04']}}: </b>{{getDocument(d.id)}}</span></div>
                        <div class="row"><span><b>{{lextranslate.i18n['5c53f7a7-0b01-4725-a728-17275550eddf']}}: </b>{{getBirthDate(d.id) | date:'dd/MM/yyyy'}}</span></div>
                        <div class="row"><span><b>{{lextranslate.i18n['895c26e7-13c8-4ccc-9b9e-55a7b8e64361']}}: </b>{{getEmail(d.id)}}</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>

          <div class="custom-details">
            <p *ngIf="column.id =='name'" class="clickable-label" [ngClass]="d[column.ngClass]"  (click)="redirectToUser(d.id)" [ngbPopover]="popContent" triggers="mouseenter:mouseleave"  container="body"
              popoverClass="my-custom-class" style="margin-top: 15px;"  >
              {{ d[column.id] }}
            </p>
           
          </div>
          <span
            *ngIf="!column.foldable && column.id !== 'status' && column.id !== 'name' && !column.actionButton && !column.pill"
            [title]="d[column.id]" class="table-text" [ngClass]="d[column.ngClass]">{{ d[column.id] }}</span>
          <span *ngIf="column.count" class="span-count">({{ d[column.count] }})</span>
        </div>

        <!-- Action button -->
        <div *ngIf="column.actionButton" style="float: right;">
          <button
            [title]="column.actionButton && column.actionButton.actionTitle ? column.actionButton.actionTitle : ''"
            class="btn btn-primary btn-transparent js-action d-flex align-items-center"
            [ngClass]="column.actionButton && column.actionButton.customClass ? column.actionButton.customClass : ''"
            style="padding-right: 10px;" (click)="callAction($event, column.actionButton.actionId, d)"
            [disabled]="d[column.id] && d[column.id].disabled" [disabled]="readonly">
            <i aria-hidden="true" style="font-size: 28px; pointer-events: none;"
              class="sidebar-item-icon material-icons"
              [ngClass]="column.actionButton && column.actionButton.customIconClass ? column.actionButton.customIconClass : ''">{{
              column.actionButton.icon }}</i>
          </button>
        </div>

        <div *ngIf="column.pill">
          <seb-lex-pill [ngStyle]="column.pill.styling(d[column.pill.propertyName])">{{
            column.pill.labeling(d[column.pill.propertyName]) }}</seb-lex-pill>
        </div>

        <!-- Imagem  -->
        <div *ngIf="column.iconText" class="text-ellipsis">
          <icon-text [iconSrc]="d[column.iconText.propertyName].iconSrc" [iconWidth]="column.iconText.iconWidth"
            [forceIcon]="true">{{ d[column.iconText.propertyName].text }}</icon-text>
        </div>

        <!-- Foldable component -->
        <foldable-content *ngIf="column.foldable" [bindLabel]="column.foldable.bindLabel"
          [items]="d[column.foldable.content] || []" [ngStyle]="column.foldable.ngStyle"
          [contentWidth]="column.foldable.contentWidth || undefined">
        </foldable-content>

        <!-- Círculo usado para exbição de status -->

        <span class="material-icons thumb_down" [ngClass]="activeReadOnly ? 'iconRedReadOnly' : 'iconThumbDown'"
          *ngIf="showStatus && column.id === 'status' && d[column.id].label == lextranslate.i18n['8e091f2c-0ad6-4134-ad8f-20b9ec710cef']"
          [title]="d[column.id].label">
          group
        </span>

        <span class="material-icons thumb_down" [ngClass]="activeReadOnly ? 'iconGreenReadOnly' : 'iconThumbUp'"
          *ngIf="showStatus && column.id === 'status' && d[column.id].label == lextranslate.i18n['68556e03-9d62-4b07-92a8-bca09af88e09']"
          [title]="d[column.id].label">
          group
        </span>

        <!-- Checkboxes para a seleção de um item -->
        <div *ngIf="showCheckboxes && column.id === 'checkboxes'">
          <div class="d-flex">
            <label class="checkbox checkbox-outline-primary"
              [ngClass]="{ 'disabled-checkbox': (d._checkbox && d._checkbox.disabled), 'hidden-checkbox': (d._checkbox && d._checkbox.hidden) }">
              <input type="checkbox" [(ngModel)]="selectedItemsPrimary[d.id]" (change)="toggleSelection(d, origin)"
                [disabled]="readonly">
              <span class="input-span"></span>
            </label>
          </div>
        </div>

        <!-- Material icon -->
        <div *ngIf="column.id === 'icon'">
          <span class="material-icons" [ngStyle]="{ color: d[column.id].color }">{{ d[column.id].name }}</span>
        </div>

      </div>
    </div>
    <div class="no-data" *ngIf="data.length === 0">
      {{ noDataText }}
    </div>
  </div>
</div>

<!-- Preloader -->
<seb-preloader [preloaderStyle]="{top: 'auto', marginTop: '32px'}" [hidden]="!preloader"></seb-preloader>

<div class="row" style="margin-top: 14px; position: relative;" [hidden]="preloader">
  <!-- Legenda da tabela -->
  <div *ngIf="showSubtitle" class="info-row__column position--lex-table">
    <span class="info-title">{{subtitle.name}}</span>
    <div style="margin-left: 4px;">
      <ul class="statuses-row statuses-row--large-margin">
        <li *ngFor="let content of subtitle.data" [ngStyle]="content.ngStyle">
          <span [ngClass]="content.ngClass"></span> {{content.label}}
        </li>
      </ul>
    </div>

  </div>

  <!-- Paginação -->
  <div *ngIf="showPagination" class="col-sm-12">
    <seb-table-paggination *ngIf="data.length !== 0" [nDefault]="initialPage" (evIndexPag)="onIndexPag($event)"
      [nItensPerPage]="itemsPerPage" [nTamanhoPagination]="paginationSize">
    </seb-table-paggination>
  </div>
</div>
